import rq from './request';

export const representative = {
  async getRepresentatives({ ex_id }) {
    return rq.get(`/get_all/representative/${ex_id}`);
  },
};
